// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import cn from 'classnames';
import { NavLink, useLocation } from 'react-router-dom';
import { useApp } from '../helpers/api-helpers';
import styles from './DesktopAppHeader.module.css';
import NavLogo from './NavLogo';
import { ProfileMenu } from './ProfileMenu';
import { PurchaseCTA } from './PurchaseCTA';

export function DesktopAppHeader() {
  const { tabs, user, authState } = useApp();

  const { pathname } = useLocation();

  return (
    <header
      className={cn(styles.wrapper, {
        [styles.newLoginHeaderWrapper]: pathname.includes('/subscribe/'),
      })}
    >
      <NavLogo />

      <nav className={styles.tabs}>
        {user && (
          <ul>
            {tabs.map(({ path, title }) => (
              <li key={path}>
                <NavLink to={path}>{title}</NavLink>
              </li>
            ))}
          </ul>
        )}
      </nav>
      {user && <ProfileMenu className={styles.profileMenu} />}
      {authState === 'signIn' && <PurchaseCTA className={styles.purchaseCTA} />}
    </header>
  );
}
